import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Model } from 'projects/core/src/include/model';
import { DossierPhase } from '../../../../dossier';
import { DossierPhasesService } from '../../../../services/dossierphases.service';
import { NotificationService } from 'projects/core/src/lib/notification.service';

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.css']
})
export class DetailPhaseComponent extends Model<DossierPhase> implements OnInit {


  notifications=[];

  constructor(
    private route1: ActivatedRoute,
    private dossierPhasesService: DossierPhasesService,
    private notificationService:NotificationService
  ) { 
    super(route1,dossierPhasesService);
  }

  ngOnInit(): void {

    this.title = 'Dettaglio Fase';
    super.ngOnInit.apply(this, arguments); 

    this.getItem();

    this.afterGetItem=()=>{
      if(this.record.alarms)
        if(!Array.isArray(this.record.alarms)){
          try{
            this.record.alarms=JSON.parse(this.record.alarms);
          }catch{
            this.record.alarms=[];
          }
          
        }
      else
        this.record.alarms=[];
    }

    this.notificationService.getNotifications("dossier",0).subscribe((result)=>{
      this.notifications=result;
    })
   
  }


  addAlarm(){
    let a:any={};
    a.id_notification=0;
    a.condition="";
    a.description="";
    a.days="";
    a.date="";

    if(!Array.isArray(this.record.alarms)){
      this.record.alarms=[];
    }

    this.record.alarms.push(a);
  }

  deleteAlarm(a){
    for(let i=0;i<this.record.alarms.length;i++){
      if(this.record.alarms[i]==a){
        this.record.alarms.splice(i,1);
        return;
      }
    }
  }

}
